import {externalLinkTypes} from '@/consts/externalLinkTypes';

export type ConfigExternalLinkBatchFlags = {
    useBatchForSso: boolean;
    useBatch: boolean;
};

export type UseConfigExternalLinkRoutingFlags = {
    isSso: boolean;
    isExternalSsoUrl: boolean;
};

/** Single source for AEM config → batch-routing booleans (use with resolveUseConfigExternalLinkBatch). */
export function resolveUseConfigExternalLinkFlags(
    linkType: string | undefined,
    ssoUrl: string | undefined
): UseConfigExternalLinkRoutingFlags {
    const isSso = externalLinkTypes.isSsoLink(linkType) || externalLinkTypes.isSsoLinkInApp(linkType);
    const isSsoUrl = externalLinkTypes.isSsoUrl(linkType);
    const isUrlWithSsoPayload = externalLinkTypes.isUrl(linkType) && Boolean(ssoUrl);
    const isExternalSsoUrl = Boolean((isSsoUrl && ssoUrl) || isUrlWithSsoPayload);

    return {isSso, isExternalSsoUrl};
}

export function resolveUseConfigExternalLinkBatch({
    isDcx,
    isSso,
    isExternalSsoUrl,
}: {
    isDcx: boolean;
    isSso: boolean;
    isExternalSsoUrl: boolean;
}): ConfigExternalLinkBatchFlags {
    const useBatchForSso = isDcx && isSso;
    const useBatch = useBatchForSso || isExternalSsoUrl;

    return {useBatchForSso, useBatch};
}

/** SSO template-only flows (Devices, Advanced diagnostic): batch on DCX markets only. */
export function resolveSsoTemplateFlowUsesBatch(isDcxMarket: boolean): boolean {
    const {useBatch} = resolveUseConfigExternalLinkBatch({
        isDcx: isDcxMarket,
        isSso: true,
        isExternalSsoUrl: false,
    });

    return useBatch;
}
